module.exports = __webpack_public_path__ + "img/big_11B05_yellow.51d4fba3.png";